type JsonLdValue = Record<string, unknown>

export function jsonLdScript(value: JsonLdValue): { 'script:ld+json': JsonLdValue } {
  return { 'script:ld+json': value }
}

export function organizationJsonLd(siteUrl: string): JsonLdValue {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${siteUrl}/#organization`,
    name: 'Clube do Tennis',
    url: siteUrl,
    description: 'Comunidade de tenistas no Brasil: rankings, desafios e perfis.',
    logo: `${siteUrl}/favicons/android-chrome-512x512.png`,
  }
}

export function webSiteJsonLd(siteUrl: string): JsonLdValue {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${siteUrl}/#website`,
    url: siteUrl,
    name: 'Clube do Tennis',
    publisher: { '@id': `${siteUrl}/#organization` },
  }
}

export function personJsonLd({
  name,
  url,
  image,
  description,
}: {
  name: string
  url: string
  image?: string
  description?: string
}): JsonLdValue {
  return {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name,
    url,
    ...(image ? { image } : {}),
    ...(description ? { description } : {}),
  }
}

export function sportsEventJsonLd({
  name,
  url,
  startDate,
  description,
  competitors,
  eventStatus,
}: {
  name: string
  url: string
  startDate?: string | null
  description: string
  competitors: Array<{ name: string; url: string }>
  eventStatus: string
}): JsonLdValue {
  return {
    '@context': 'https://schema.org',
    '@type': 'SportsEvent',
    name,
    url,
    sport: 'Tennis',
    description,
    eventStatus,
    ...(startDate ? { startDate } : {}),
    competitor: competitors.map(competitor => ({
      '@type': 'Person',
      name: competitor.name,
      url: competitor.url,
    })),
  }
}

export function rankingPageJsonLd({
  name,
  url,
  description,
  participantCount,
}: {
  name: string
  url: string
  description: string
  participantCount: number
}): JsonLdValue {
  return {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name,
    url,
    description,
    about: {
      '@type': 'SportsOrganization',
      name,
      sport: 'Tennis',
      numberOfEmployees: participantCount,
    },
  }
}

export function articleJsonLd({
  headline,
  description,
  url,
  image,
  datePublished,
  dateModified,
}: {
  headline: string
  description: string
  url: string
  image?: string
  datePublished?: string
  dateModified?: string
}): JsonLdValue {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    description,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Clube do Tennis',
    },
    ...(image ? { image: [image] } : {}),
    ...(datePublished ? { datePublished } : {}),
    ...(dateModified ? { dateModified } : {}),
  }
}

export function collectionPageJsonLd({
  name,
  url,
  description,
}: {
  name: string
  url: string
  description: string
}): JsonLdValue {
  return {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name,
    url,
    description,
  }
}
